// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { LoginLoginAccessTokenData, LoginLoginAccessTokenResponse, LoginTestTokenResponse, LoginRecoverPasswordData, LoginRecoverPasswordResponse, LoginResetPasswordData, LoginResetPasswordResponse, LoginRecoverPasswordHtmlContentData, LoginRecoverPasswordHtmlContentResponse, UsersReadUsersData, UsersReadUsersResponse, UsersCreateUserData, UsersCreateUserResponse, UsersReadUserMeResponse, UsersDeleteUserMeResponse, UsersUpdateUserMeData, UsersUpdateUserMeResponse, UsersUpdatePasswordMeData, UsersUpdatePasswordMeResponse, UsersRegisterUserData, UsersRegisterUserResponse, UsersReadUserByIdData, UsersReadUserByIdResponse, UsersUpdateUserData, UsersUpdateUserResponse, UsersDeleteUserData, UsersDeleteUserResponse, UtilsTestEmailData, UtilsTestEmailResponse, UtilsHealthCheckResponse, UtilsSqliteHealthCheckData, UtilsSqliteHealthCheckResponse, ItemsReadItemsData, ItemsReadItemsResponse, ItemsCreateItemData, ItemsCreateItemResponse, ItemsReadItemData, ItemsReadItemResponse, ItemsUpdateItemData, ItemsUpdateItemResponse, ItemsDeleteItemData, ItemsDeleteItemResponse, JudgmentsTriggerJudgmentProcessingResponse, JudgmentsReadJudgmentsData, JudgmentsReadJudgmentsResponse, JudgmentsListAllFeedbackData, JudgmentsListAllFeedbackResponse, JudgmentsReadJudgmentData, JudgmentsReadJudgmentResponse, JudgmentsDeleteJudgmentData, JudgmentsDeleteJudgmentResponse, JudgmentsGetJudgmentFileData, JudgmentsGetJudgmentFileResponse, JudgmentsGetJudgmentTextData, JudgmentsGetJudgmentTextResponse, JudgmentsGetJudgmentStatusData, JudgmentsGetJudgmentStatusResponse, JudgmentsGetJudgmentResultsData, JudgmentsGetJudgmentResultsResponse, JudgmentsGetJudgmentClassificationData, JudgmentsGetJudgmentClassificationResponse, JudgmentsReprocessJudgmentData, JudgmentsReprocessJudgmentResponse, JudgmentsGetQueueStatsResponse, JudgmentsGetJudgmentQueueStatusData, JudgmentsGetJudgmentQueueStatusResponse, JudgmentsProcessQueueManuallyData, JudgmentsProcessQueueManuallyResponse, JudgmentsUploadJudgmentData, JudgmentsUploadJudgmentResponse, JudgmentsSubmitFeedbackData, JudgmentsSubmitFeedbackResponse, JudgmentsUpdateFeedbackStatusData, JudgmentsUpdateFeedbackStatusResponse, SearchSearchJudgmentsData, SearchSearchJudgmentsResponse, AvtalListAvtalData, AvtalListAvtalResponse, AvtalGetAvtalDetailData, AvtalGetAvtalDetailResponse, SqliteTestHealthCheckSqliteServiceData, SqliteTestHealthCheckSqliteServiceResponse, SqliteTestTestAvtalListData, SqliteTestTestAvtalListResponse, SqliteTestTestJudgmentsListData, SqliteTestTestJudgmentsListResponse, SqliteViewerGetDatabaseInfoData, SqliteViewerGetDatabaseInfoResponse, SqliteViewerGetTableDataData, SqliteViewerGetTableDataResponse, SqliteViewerExecuteQueryData, SqliteViewerExecuteQueryResponse, ChatChatEndpointData, ChatChatEndpointResponse, ChatChatHealthCheckResponse, PrivateCreateUserData, PrivateCreateUserResponse } from './types.gen';

/**
 * Login Access Token
 * OAuth2 compatible token login, get an access token for future requests
 * @param data The data for the request.
 * @param data.formData
 * @returns Token Successful Response
 * @throws ApiError
 */
export const loginLoginAccessToken = (data: LoginLoginAccessTokenData): CancelablePromise<LoginLoginAccessTokenResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/login/access-token',
        formData: data.formData,
        mediaType: 'application/x-www-form-urlencoded',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Test Token
 * Test access token
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const loginTestToken = (): CancelablePromise<LoginTestTokenResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/login/test-token'
    });
};

/**
 * Recover Password
 * Password Recovery
 * @param data The data for the request.
 * @param data.email
 * @returns Message Successful Response
 * @throws ApiError
 */
export const loginRecoverPassword = (data: LoginRecoverPasswordData): CancelablePromise<LoginRecoverPasswordResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/password-recovery/{email}',
        path: {
            email: data.email
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Reset Password
 * Reset password
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Message Successful Response
 * @throws ApiError
 */
export const loginResetPassword = (data: LoginResetPasswordData): CancelablePromise<LoginResetPasswordResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/reset-password/',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Recover Password Html Content
 * HTML Content for Password Recovery
 * @param data The data for the request.
 * @param data.email
 * @returns string Successful Response
 * @throws ApiError
 */
export const loginRecoverPasswordHtmlContent = (data: LoginRecoverPasswordHtmlContentData): CancelablePromise<LoginRecoverPasswordHtmlContentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/password-recovery-html-content/{email}',
        path: {
            email: data.email
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Read Users
 * Retrieve users.
 * @param data The data for the request.
 * @param data.skip
 * @param data.limit
 * @returns UsersPublic Successful Response
 * @throws ApiError
 */
export const usersReadUsers = (data: UsersReadUsersData = {}): CancelablePromise<UsersReadUsersResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/',
        query: {
            skip: data.skip,
            limit: data.limit
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Create User
 * Create new user.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const usersCreateUser = (data: UsersCreateUserData): CancelablePromise<UsersCreateUserResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Read User Me
 * Get current user.
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const usersReadUserMe = (): CancelablePromise<UsersReadUserMeResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/me'
    });
};

/**
 * Delete User Me
 * Delete own user.
 * @returns Message Successful Response
 * @throws ApiError
 */
export const usersDeleteUserMe = (): CancelablePromise<UsersDeleteUserMeResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/users/me'
    });
};

/**
 * Update User Me
 * Update own user.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const usersUpdateUserMe = (data: UsersUpdateUserMeData): CancelablePromise<UsersUpdateUserMeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/users/me',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Update Password Me
 * Update own password.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Message Successful Response
 * @throws ApiError
 */
export const usersUpdatePasswordMe = (data: UsersUpdatePasswordMeData): CancelablePromise<UsersUpdatePasswordMeResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/users/me/password',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Register User
 * Create new user without the need to be logged in.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const usersRegisterUser = (data: UsersRegisterUserData): CancelablePromise<UsersRegisterUserResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/users/signup',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Read User By Id
 * Get a specific user by id.
 * @param data The data for the request.
 * @param data.userId
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const usersReadUserById = (data: UsersReadUserByIdData): CancelablePromise<UsersReadUserByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/users/{user_id}',
        path: {
            user_id: data.userId
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Update User
 * Update a user.
 * @param data The data for the request.
 * @param data.userId
 * @param data.requestBody
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const usersUpdateUser = (data: UsersUpdateUserData): CancelablePromise<UsersUpdateUserResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/users/{user_id}',
        path: {
            user_id: data.userId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Delete User
 * Delete a user.
 * @param data The data for the request.
 * @param data.userId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const usersDeleteUser = (data: UsersDeleteUserData): CancelablePromise<UsersDeleteUserResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/users/{user_id}',
        path: {
            user_id: data.userId
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Test Email
 * Test emails.
 * @param data The data for the request.
 * @param data.emailTo
 * @returns Message Successful Response
 * @throws ApiError
 */
export const utilsTestEmail = (data: UtilsTestEmailData): CancelablePromise<UtilsTestEmailResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/utils/test-email/',
        query: {
            email_to: data.emailTo
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Health Check
 * @returns boolean Successful Response
 * @throws ApiError
 */
export const utilsHealthCheck = (): CancelablePromise<UtilsHealthCheckResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/utils/health-check/'
    });
};

/**
 * Sqlite Health Check
 * Check SQLite service health (no authentication required).
 * @param data The data for the request.
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const utilsSqliteHealthCheck = (data: UtilsSqliteHealthCheckData = {}): CancelablePromise<UtilsSqliteHealthCheckResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/utils/sqlite-health/',
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Read Items
 * Retrieve items.
 * @param data The data for the request.
 * @param data.skip
 * @param data.limit
 * @returns ItemsPublic Successful Response
 * @throws ApiError
 */
export const itemsReadItems = (data: ItemsReadItemsData = {}): CancelablePromise<ItemsReadItemsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/items/',
        query: {
            skip: data.skip,
            limit: data.limit
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Create Item
 * Create new item.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ItemPublic Successful Response
 * @throws ApiError
 */
export const itemsCreateItem = (data: ItemsCreateItemData): CancelablePromise<ItemsCreateItemResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/items/',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Read Item
 * Get item by ID.
 * @param data The data for the request.
 * @param data.id
 * @returns ItemPublic Successful Response
 * @throws ApiError
 */
export const itemsReadItem = (data: ItemsReadItemData): CancelablePromise<ItemsReadItemResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/items/{id}',
        path: {
            id: data.id
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Update Item
 * Update an item.
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns ItemPublic Successful Response
 * @throws ApiError
 */
export const itemsUpdateItem = (data: ItemsUpdateItemData): CancelablePromise<ItemsUpdateItemResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/v1/items/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Delete Item
 * Delete an item.
 * @param data The data for the request.
 * @param data.id
 * @returns Message Successful Response
 * @throws ApiError
 */
export const itemsDeleteItem = (data: ItemsDeleteItemData): CancelablePromise<ItemsDeleteItemResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/items/{id}',
        path: {
            id: data.id
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Trigger Judgment Processing
 * Processing not available - using SQLite service for data access only.
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsTriggerJudgmentProcessing = (): CancelablePromise<JudgmentsTriggerJudgmentProcessingResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/judgments/process'
    });
};

/**
 * Read Judgments
 * Retrieve judgments with pagination and optional filtering, including classification data.
 *
 * - avtal_id: Filter by specific avtal (contract)
 * - paragraph_id: Filter by specific avtal paragraph
 * - status: Filter by judgment status (uploaded, processing, completed, failed)
 * @param data The data for the request.
 * @param data.skip
 * @param data.limit
 * @param data.avtalId
 * @param data.paragraphId
 * @param data.status
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns JudgmentsWithClassificationPublic Successful Response
 * @throws ApiError
 */
export const judgmentsReadJudgments = (data: JudgmentsReadJudgmentsData = {}): CancelablePromise<JudgmentsReadJudgmentsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/',
        query: {
            skip: data.skip,
            limit: data.limit,
            avtal_id: data.avtalId,
            paragraph_id: data.paragraphId,
            status: data.status,
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * List All Feedback
 * List all feedback entries. Admin only.
 * @param data The data for the request.
 * @param data.skip
 * @param data.limit
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns UserFeedbackListResponse Successful Response
 * @throws ApiError
 */
export const judgmentsListAllFeedback = (data: JudgmentsListAllFeedbackData = {}): CancelablePromise<JudgmentsListAllFeedbackResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/feedback',
        query: {
            skip: data.skip,
            limit: data.limit,
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Read Judgment
 * Get judgment by ID.
 * @param data The data for the request.
 * @param data.judgmentId
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns JudgmentPublic Successful Response
 * @throws ApiError
 */
export const judgmentsReadJudgment = (data: JudgmentsReadJudgmentData): CancelablePromise<JudgmentsReadJudgmentResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/{judgment_id}',
        path: {
            judgment_id: data.judgmentId
        },
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Delete Judgment
 * Judgment deletion not available - using SQLite service for data access only.
 * @param data The data for the request.
 * @param data.judgmentId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsDeleteJudgment = (data: JudgmentsDeleteJudgmentData): CancelablePromise<JudgmentsDeleteJudgmentResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v1/judgments/{judgment_id}',
        path: {
            judgment_id: data.judgmentId
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Judgment File
 * Serve the PDF file for a judgment.
 * @param data The data for the request.
 * @param data.judgmentId
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const judgmentsGetJudgmentFile = (data: JudgmentsGetJudgmentFileData): CancelablePromise<JudgmentsGetJudgmentFileResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/{judgment_id}/file',
        path: {
            judgment_id: data.judgmentId
        },
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Judgment Text
 * Get the extracted text content for a judgment.
 * @param data The data for the request.
 * @param data.judgmentId
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const judgmentsGetJudgmentText = (data: JudgmentsGetJudgmentTextData): CancelablePromise<JudgmentsGetJudgmentTextResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/{judgment_id}/text',
        path: {
            judgment_id: data.judgmentId
        },
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Judgment Status
 * Status tracking not available - using SQLite service for data access only.
 * @param data The data for the request.
 * @param data.judgmentId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsGetJudgmentStatus = (data: JudgmentsGetJudgmentStatusData): CancelablePromise<JudgmentsGetJudgmentStatusResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/{judgment_id}/status',
        path: {
            judgment_id: data.judgmentId
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Judgment Results
 * Processing results not available - using SQLite service for data access only.
 * @param data The data for the request.
 * @param data.judgmentId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsGetJudgmentResults = (data: JudgmentsGetJudgmentResultsData): CancelablePromise<JudgmentsGetJudgmentResultsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/{judgment_id}/results',
        path: {
            judgment_id: data.judgmentId
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Judgment Classification
 * Get AI classification results for a judgment.
 * @param data The data for the request.
 * @param data.judgmentId
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns JudgmentClassificationResponse Successful Response
 * @throws ApiError
 */
export const judgmentsGetJudgmentClassification = (data: JudgmentsGetJudgmentClassificationData): CancelablePromise<JudgmentsGetJudgmentClassificationResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/{judgment_id}/classification',
        path: {
            judgment_id: data.judgmentId
        },
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Reprocess Judgment
 * Judgment reprocessing not available - using SQLite service for data access only.
 * @param data The data for the request.
 * @param data.judgmentId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsReprocessJudgment = (data: JudgmentsReprocessJudgmentData): CancelablePromise<JudgmentsReprocessJudgmentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/judgments/{judgment_id}/reprocess',
        path: {
            judgment_id: data.judgmentId
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Queue Stats
 * Queue statistics not available - using SQLite service for data access only.
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsGetQueueStats = (): CancelablePromise<JudgmentsGetQueueStatsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/queue/stats'
    });
};

/**
 * Get Judgment Queue Status
 * Queue status not available - using SQLite service for data access only.
 * @param data The data for the request.
 * @param data.judgmentId
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsGetJudgmentQueueStatus = (data: JudgmentsGetJudgmentQueueStatusData): CancelablePromise<JudgmentsGetJudgmentQueueStatusResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/judgments/{judgment_id}/queue',
        path: {
            judgment_id: data.judgmentId
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Process Queue Manually
 * Queue processing not available - using SQLite service for data access only.
 * @param data The data for the request.
 * @param data.continuous
 * @param data.maxTasks
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsProcessQueueManually = (data: JudgmentsProcessQueueManuallyData = {}): CancelablePromise<JudgmentsProcessQueueManuallyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/judgments/queue/process',
        query: {
            continuous: data.continuous,
            max_tasks: data.maxTasks
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Upload Judgment
 * File upload not available - using SQLite service for data access only.
 * @param data The data for the request.
 * @param data.formData
 * @returns Message Successful Response
 * @throws ApiError
 */
export const judgmentsUploadJudgment = (data: JudgmentsUploadJudgmentData): CancelablePromise<JudgmentsUploadJudgmentResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/judgments/upload',
        formData: data.formData,
        mediaType: 'multipart/form-data',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Submit Feedback
 * Submit feedback for a judgment.
 * @param data The data for the request.
 * @param data.judgmentId
 * @param data.requestBody
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns UserFeedbackPublic Successful Response
 * @throws ApiError
 */
export const judgmentsSubmitFeedback = (data: JudgmentsSubmitFeedbackData): CancelablePromise<JudgmentsSubmitFeedbackResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/judgments/{judgment_id}/feedback',
        path: {
            judgment_id: data.judgmentId
        },
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Update Feedback Status
 * Update feedback status (mark as taken care of). Admin only.
 * @param data The data for the request.
 * @param data.feedbackId
 * @param data.requestBody
 * @returns UserFeedbackPublic Successful Response
 * @throws ApiError
 */
export const judgmentsUpdateFeedbackStatus = (data: JudgmentsUpdateFeedbackStatusData): CancelablePromise<JudgmentsUpdateFeedbackStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v1/judgments/feedback/{feedback_id}',
        path: {
            feedback_id: data.feedbackId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Search Judgments
 * Unified endpoint for searching and filtering judgments.
 *
 * If a search query (q) is provided, performs semantic search using OpenAI vector store.
 * If no search query is provided, returns all judgments with optional filtering.
 *
 * - **q**: Search query string (optional - if not provided, returns all judgments)
 * - **limit**: Maximum number of results (1-1000, default: 100)
 * - **skip**: Number of results to skip for pagination (default: 0)
 * - **avtal_id**: Filter by specific avtal (contract)
 * - **paragraph_id**: Filter by specific avtal paragraph
 * - **status**: Filter by judgment status (uploaded, processing, completed, failed)
 *
 * Returns judgments with their classifications in the same format as the main judgments endpoint.
 * @param data The data for the request.
 * @param data.q Search query string (optional - if not provided, returns all judgments with filters)
 * @param data.limit Maximum number of results to return
 * @param data.skip Number of results to skip for pagination
 * @param data.avtalId Filter by specific avtal (contract)
 * @param data.paragraphId Filter by specific avtal paragraph
 * @param data.status Filter by judgment status (uploaded, processing, completed, failed)
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns JudgmentsWithClassificationPublic Successful Response
 * @throws ApiError
 */
export const searchSearchJudgments = (data: SearchSearchJudgmentsData = {}): CancelablePromise<SearchSearchJudgmentsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/search/',
        query: {
            q: data.q,
            limit: data.limit,
            skip: data.skip,
            avtal_id: data.avtalId,
            paragraph_id: data.paragraphId,
            status: data.status,
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * List Avtal
 * List all avtal (contracts) with just name and ID.
 * @param data The data for the request.
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns AvtalListResponse Successful Response
 * @throws ApiError
 */
export const avtalListAvtal = (data: AvtalListAvtalData = {}): CancelablePromise<AvtalListAvtalResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/avtal/',
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Avtal Detail
 * Get avtal details with all chapters, paragraphs, and LegalProvision counts.
 * @param data The data for the request.
 * @param data.avtalId
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns AvtalDetailResponse Successful Response
 * @throws ApiError
 */
export const avtalGetAvtalDetail = (data: AvtalGetAvtalDetailData): CancelablePromise<AvtalGetAvtalDetailResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/avtal/{avtal_id}',
        path: {
            avtal_id: data.avtalId
        },
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Health Check Sqlite Service
 * Check health of SQLite service.
 * @param data The data for the request.
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const sqliteTestHealthCheckSqliteService = (data: SqliteTestHealthCheckSqliteServiceData = {}): CancelablePromise<SqliteTestHealthCheckSqliteServiceResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/sqlite-test/health',
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Test Avtal List
 * Test avtal listing from SQLite.
 * @param data The data for the request.
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const sqliteTestTestAvtalList = (data: SqliteTestTestAvtalListData = {}): CancelablePromise<SqliteTestTestAvtalListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/sqlite-test/test-avtal',
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Test Judgments List
 * Test judgments listing from SQLite.
 * @param data The data for the request.
 * @param data.dbPath
 * @param data.fileBasePath
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const sqliteTestTestJudgmentsList = (data: SqliteTestTestJudgmentsListData = {}): CancelablePromise<SqliteTestTestJudgmentsListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/sqlite-test/test-judgments',
        query: {
            db_path: data.dbPath,
            file_base_path: data.fileBasePath
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Database Info
 * Get information about all tables and their data from the SQLite database.
 * @param data The data for the request.
 * @param data.limit
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const sqliteViewerGetDatabaseInfo = (data: SqliteViewerGetDatabaseInfoData = {}): CancelablePromise<SqliteViewerGetDatabaseInfoResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/sqlite-viewer/database',
        query: {
            limit: data.limit
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Get Table Data
 * Get data from a specific table with pagination and search.
 * @param data The data for the request.
 * @param data.tableName
 * @param data.offset
 * @param data.limit
 * @param data.search
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const sqliteViewerGetTableData = (data: SqliteViewerGetTableDataData): CancelablePromise<SqliteViewerGetTableDataResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/sqlite-viewer/table/{table_name}',
        path: {
            table_name: data.tableName
        },
        query: {
            offset: data.offset,
            limit: data.limit,
            search: data.search
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Execute Query
 * Execute a custom SQL query (SELECT only for safety).
 * @param data The data for the request.
 * @param data.q
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const sqliteViewerExecuteQuery = (data: SqliteViewerExecuteQueryData): CancelablePromise<SqliteViewerExecuteQueryResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/sqlite-viewer/query',
        query: {
            q: data.q
        },
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Chat Endpoint
 * Chat endpoint for Assistant UI integration.
 * Expects request with messages array and returns streaming response.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const chatChatEndpoint = (data: ChatChatEndpointData): CancelablePromise<ChatChatEndpointResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/chat/chat',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};

/**
 * Chat Health Check
 * Check if chat service is configured and available.
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const chatChatHealthCheck = (): CancelablePromise<ChatChatHealthCheckResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v1/chat/chat/health'
    });
};

/**
 * Create User
 * Create a new user.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UserPublic Successful Response
 * @throws ApiError
 */
export const privateCreateUser = (data: PrivateCreateUserData): CancelablePromise<PrivateCreateUserResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/private/users/',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            422: 'Validation Error'
        }
    });
};